import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { brand } from "../mock";

const navItems = [
  { label: "Fonctionnalités", href: "/#fonctionnalites" },
  { label: "Expéditions", href: "/#expeditions" },
  { label: "Missions", href: "/#missions" },
  { label: "Support", href: "/support" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-black border-b border-white/5">
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 h-14 flex items-center justify-between">
        <Link to="/" className="velis-wordmark text-white text-base">
          {brand.name}
        </Link>

        <div className="hidden md:flex items-center gap-7">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="text-sm text-white/80 hover:text-white font-medium"
            >
              {item.label}
            </a>
          ))}
        </div>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-velis-dark/95 backdrop-blur-md border-b border-white/5 px-6 py-4 flex flex-col gap-4">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={() => setOpen(false)}
              className="text-white/80 hover:text-white font-medium"
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};

export default Navbar;
